import { Typography, Box, styled } from "@mui/material";

export const BetDistributionSectionContainer = styled(Box)({
    margin: "12px 0",
});

export const BetDistributionSectionTitle = styled(Typography)({
    fontSize: "14px",
    color: "var(--community-color-secondary-text)",
    marginBottom: "8px",
    fontWeight: "400",
    textAlign: "center",
});
